import { denormalize } from "normalizr";
import { fundingRequest } from "../../../api/schema";

const getDebtorInvoices = state => {
  try {
    const items = state.debtor.invoices.ids;

    const denormalized = denormalize(
      { items },
      { items: [fundingRequest] },
      state.entities
    );

    return denormalized.items;
  } catch (err) {
    return [];
  }
};

export default getDebtorInvoices;
